<template>
  <div class="index">
    <div class="title">
      <img
        src="@/assets/圆圈.png"
        alt
      >
      <div>基本信息</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="8">
          <div>
            <div class="key">
              商品名称：
            </div>
            <div
              class="value"
              style="max-width: 180px;"
            >
              {{ info.name }}
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">
              商品编码：
            </div>
            <div class="value">
              {{ info.code }}
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <div class="key">
              商品条码：
            </div>
            <div class="value">
              {{ info.barcode }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col
          v-show="info.attributeName"
          :span="8"
        >
          <div>
            <div class="key">
              商品属性名称：
            </div>
            <div class="value">
              {{ info.attributeName }}
            </div>
          </div>
        </el-col>
        <el-col
          v-show="info.spec"
          :span="8"
        >
          <div>
            <div class="key">
              规格：
            </div>
            <div class="value">
              {{ info.spec }}
            </div>
          </div>
        </el-col>
        <el-col
          v-show="info.shelfLife"
          :span="8"
        >
          <div>
            <div class="key">
              保质期：
            </div>
            <div class="value">
              {{ info.shelfLife }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        v-show="info.basis"
        class="row"
      >
        <el-col :span="24">
          <div>
            <div class="key">
              配料或主要成分：
            </div>
            <div class="value">
              {{ info.basis }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        v-show="info.hint"
        class="row"
      >
        <el-col :span="24">
          <div>
            <div class="key">
              致敏物质提示：
            </div>
            <div class="value">
              {{ info.hint }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        v-if="info.images"
        class="row"
      >
        <el-col :span="24">
          <div>
            <div class="key">
              商品图片：
            </div>
            <div class="value">
              <ProductImages :images="info.images" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        v-show="info.storage"
        class="row"
      >
        <el-col :span="24">
          <div>
            <div class="key">
              存储方法：
            </div>
            <div class="value">
              {{ info.storage }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        v-show="info.provenance"
        class="row"
      >
        <el-col :span="24">
          <div>
            <div class="key">
              商品产地：
            </div>
            <div class="value">
              {{ info.provenance }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img
        src="@/assets/圆圈.png"
        alt
      >
      <div>食赏妙味</div>
    </div>
    <div class="content">
      <el-row class="row">
        <el-col :span="24">
          <div>
            <div class="key">
              营养成分：
            </div>
            <div class="value">
              <el-table
                :data="info.productFoodWikiNutrientList"
                border
                size="mini"
                style="width: 100%"
                cell-class-name="wikiTd"
              >
                <el-table-column
                  label="项目"
                  width="150"
                  prop="item"
                />
                <el-table-column
                  label="每100克(g)"
                  width="150"
                  prop="heat"
                />
                <el-table-column
                  label="营养参考价值%"
                  prop="ref"
                  width="150"
                />
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        v-show="info.usages"
        class="row"
      >
        <el-col :span="24">
          <div>
            <div class="key">
              使用/食用方法：
            </div>
            <div class="value">
              {{ info.usages }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img
        src="@/assets/圆圈.png"
        alt
      >
      <div>商品故事</div>
    </div>
    <div class="content">
      <el-row
        v-show="info.story"
        class="row"
      >
        <el-col :span="24">
          <div>
            <div class="key">
              商品故事：
            </div>
            <div class="value">
              {{ info.story }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        v-show="info.brandStory"
        class="row"
      >
        <el-col :span="24">
          <div>
            <div class="key">
              品牌故事：
            </div>
            <div class="value">
              {{ info.brandStory }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      <img
        src="@/assets/圆圈.png"
        alt
      >
      <div>商品营销</div>
    </div>
    <div class="content">
      <el-row
        v-show="info.sellingPoint"
        class="row"
      >
        <el-col :span="24">
          <div class="key">
            商品卖点：
          </div>
          <div class="value">
            {{ info.sellingPoint }}
          </div>
        </el-col>
      </el-row>
      <el-row
        v-show="info.comparativeAdvantage"
        class="row"
      >
        <el-col :span="24">
          <div class="key">
            市场对比优势：
          </div>
          <div class="value">
            {{ info.comparativeAdvantage }}
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col
          v-show="info.provenanceAdvantage"
          :span="24"
        >
          <div class="key">
            产地特点及优势：
          </div>
          <div class="value">
            {{ info.provenanceAdvantage }}
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col
          v-show="info.certificateInformation"
          :span="24"
        >
          <div class="key">
            认证资料/荣誉证书：
          </div>
          <div class="value">
            {{ info.certificateInformation }}
          </div>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col
          v-show="info.lineAdvantage"
          :span="24"
        >
          <div class="key">
            工厂/生产线特点及优势：
          </div>
          <div class="value">
            {{ info.lineAdvantage }}
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ProductImages from '@/components/ProductImages.vue'
export default {
  name: 'ProductBase',
  components: {
    ProductImages
  },
  props: ['info']
}
</script>

<style lang="less" scoped>
.index {
  width: 1100px;

  font-size: 14px;

  .title {
    margin: 20px 0;
    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }
    div {
      display: inline-block;
      width: 80px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .row {
    line-height: 20px;
    min-height: 50px;
    padding: 15px 20px;
    .active{
      cursor: pointer;
      color: #1B994F;
    }
  }

  .content {
    .row:nth-child(2n + 1) {
      background: #f7faf8;
    }
    .wikiTd{
      text-align: center;
    }
  }

  // .row-dark {
  //   background: #f7faf8;
  // }

  .key {
    display: inline-block;
    width: 100px;
    color: #666;
    vertical-align: top;
  }
  .value {
    display: inline-block;
    max-width: 960px;
    color: #333;
  }
}
</style>
